import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const UpdateWomanLedModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  womanLed, onWomanLedChange, womanLedOptions, womanLedError, setWomanLedError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update women led status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF 
      type='text' 
      name='womanLed' 
      label='Women led' 
      value={womanLed} 
      onChange={onWomanLedChange} 
      optionList={womanLedOptions}
      error={womanLedError} 
      setError={setWomanLedError}
    />
  </ModalFormUI>

export default UpdateWomanLedModalUI
